import {AsyncPipe} from '@angular/common'
import {Component, inject, OnInit} from '@angular/core'
import {FormControl, ReactiveFormsModule} from '@angular/forms'
import {MatButton} from '@angular/material/button'
import {MatOption} from '@angular/material/core'
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogTitle
} from '@angular/material/dialog'
import {MatFormField, MatLabel} from '@angular/material/form-field'
import {MatSelect} from '@angular/material/select'
import {AdminService} from '../../services/admin.service'

@Component({
  selector: 'spb-delegate',
  templateUrl: './delegate.component.html',
  styleUrls: ['./delegate.component.scss'],
  imports: [
    MatDialogTitle,
    MatDialogContent,
    MatFormField,
    MatLabel,
    MatSelect,
    ReactiveFormsModule,
    MatOption,
    MatDialogActions,
    MatButton,
    MatDialogClose,
    AsyncPipe
  ]
})

export class DelegateComponent implements OnInit {
  public readonly adminService = inject(AdminService)

  /**
   * Input value from callee, set through data
   */
  public selectedValue = ''

  /**
   * Simple form control that holds data.
   */
  public selectDelegate = new FormControl<string>('')

  private readonly data = inject(MAT_DIALOG_DATA)

  public ngOnInit(): void {
    this.selectDelegate.setValue(this.data.application.adminData.assignee)
    this.selectedValue = this.data.application.adminData.assignee
  }

  public save(): void {
    this.data.application.adminData.assignee = this.selectDelegate.value
    this.adminService.saveApplication(this.data.application)
  }
}
